import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];
  static values = { activeDate: String };

  selectDay(e) {
    this.activeDateValue = e.params.date;
  }

  activeDateValueChanged(date) {
    this.panelTargets.forEach((p) => {
      p.classList.toggle("hidden", p.dataset.scheduleMonthDate !== date);
    });
  }
}
